import { render, staticRenderFns } from "./PopupList.vue?vue&type=template&id=6ae1a2e6&scoped=true"
import script from "./PopupList.vue?vue&type=script&lang=js"
export * from "./PopupList.vue?vue&type=script&lang=js"
import style0 from "./PopupList.vue?vue&type=style&index=0&id=6ae1a2e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae1a2e6",
  null
  
)

export default component.exports